import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-dk",
  "use": "icon-icon-dk-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-dk\">\n  <path fill=\"#c8102e\" d=\"M0 0h512.1v512H0z\" />\n  <path fill=\"#fff\" d=\"M144 0h73.1v512H144z\" />\n  <path fill=\"#fff\" d=\"M0 219.4h512.1v73.2H0z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol